export default (props, inject) => {
  const seoMetaHelper = function (seoObject) {
    const config = props?.store?.state?.appState?.config;
    const suffix = [
      config?.suffixDivider,
      config?.suffixTitle,
    ].filter((t) => !!t).join(' ');

    if (seoObject?.title) {
      seoObject.title = [
        seoObject.title,
        suffix,
      ].filter((t) => !!t).join(' ');
    }
    if ((seoObject?.meta || []).find((t) => t.name === 'og:title')) {
      (seoObject?.meta || []).find((t) => t.name === 'og:title').content = [
        (seoObject?.meta || []).find((t) => t.name === 'og:title').content,
        suffix,
      ].filter((t) => !!t).join(' ');
    }

    return seoObject;
  };
  inject('seoMetaHelper', seoMetaHelper);
};
